import { IStore } from 'old-store/types';
import { createSelector } from 'reselect';
import { find, flatten, findIndex, cloneDeep, filter } from 'lodash';
import { IProductGroup, IProduct } from './types';

export const getProductsStore = ({ products }: IStore) => cloneDeep(products);
export const getProductSuggestions = ({ products }: IStore) => products.suggestions;
export const getNonDigitalProductSuggestions = ({ products }: IStore) =>
  products.suggestions.filter((s) => s.productGroupId !== 'digital');
export const getIsProductsLoading = createSelector(getProductsStore, ({ isLoading }) => isLoading);
export const getProductsGroupsSelector = createSelector(getProductsStore, ({ groups }) => groups);
export const getProductGroupByID = createSelector(
  getProductsGroupsSelector,
  (groups) => (groupID: string) => find(groups, { _id: groupID })
);
export const getProductGroupBySlug = createSelector(
  getProductsGroupsSelector,
  (groups) => (groupSlug: string) => find(groups, { slug: groupSlug })
);
export const getProductGroupByStartsWithSlug = createSelector(
  getProductsGroupsSelector,
  (groups) => (groupSlug: string) =>
    find(groups, (group: IProductGroup) => group?.slug?.startsWith(groupSlug))
);
export const getProductGroupsByStartsWithSlug = createSelector(
  getProductsGroupsSelector,
  (groups) => (groupSlug: string) =>
    filter(groups, (group: IProductGroup) => Boolean(group?.slug?.startsWith(groupSlug)))
);
export const getAllProduct = createSelector(getProductsGroupsSelector, (groups) =>
  flatten(groups.map((group) => group.products))
);
export const getProductByID = createSelector(
  getAllProduct,
  (products) => (productID: string) => find(products, { _id: productID })
);
export const getProductBySlug = createSelector(
  getAllProduct,
  (products) => (productSlug: string) => find(products, { slug: productSlug })
);
export const getProductByStartsWithSlug = createSelector(
  getAllProduct,
  (products) => (productSlug: string) =>
    find(products, (product: IProduct) => product?.slug?.startsWith(productSlug))
);
export const getProductIndex = createSelector(
  getAllProduct,
  (products) => (productSlug: string) => findIndex(products, { slug: productSlug })
);
export const getAllNonDigitalProduct = createSelector(getAllProduct, (products) =>
  products.filter((p) => p._productGroup !== 'digital')
);
